/**
 * "Report" under the AI notice (ADR-0095): our public form, in the
 * visitor's language (Drupal decides the URL), with the page's origin and
 * the chatbot's public site_key so our staff know which one. Never the full
 * page address: its path or query may carry the visitor's data.
 */
export function reportHref(reportUrl, origin, siteKey) {
  let url;
  try {
    url = new URL(reportUrl);
  } catch {
    return null;
  }
  const local = url.hostname === 'localhost' || url.hostname.endsWith('.localhost');
  if (url.protocol !== 'https:' && !(local && url.protocol === 'http:')) return null;
  if (origin) url.searchParams.set('site', origin);
  if (siteKey) url.searchParams.set('chatbot', siteKey);
  return url.toString();
}
